export function formatCurrency(amountInCents, inDollars = false) {
  let amountInDollars = amountInCents;
  if (!inDollars) {
    amountInDollars = amountInCents / 100;
  } else {
    amountInDollars = parseFloat(amountInDollars);
  }  
  return amountInDollars.toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
  });
}

// export function formatCurrency(amountInCents) {
//   const str = String(amountInCents);

//   if (str.length === 1) {
//     return `0.0${str}`;
//   } else if (str.length === 2) {
//     return `0.${str}`;
//   } else {
//     return `${str.slice(0, -2)}.${str.slice(-2)}`;
//   }
// }
